import gql from 'graphql-tag';

export const GET_PRESCRIPTIONS = gql`
  query Prescriptions {
    me {
      prescriptions(first: 200) {
        data {
          id
          type_id
          add_int
          add_near
          left_int_add
          right_int_add
          left_near_add
          right_near_add
          right_sph
          left_axis
          left_cyl
          left_sph
          right_axis
          right_cyl
          note
          created_at
          standardised_prescription_display_array {
            add
            right
            left
          }
          pd {
            id
            type
            binocular_dist_pd
            right_monocular_dist_pd
            left_monocular_dist_pd
            right_height_multifocal
            left_height_multifocal
            frame_size
          }
          files {
            id
            file_name
            thumbnail_path
            full_path
          }
          contactLensPrescription {
            right_near_add
            left_near_add
            right_notes
            left_notes
            left_colour
            left_diameter
            left_base_curve
            left_brand
            left_type
            left_supplier
            right_colour
            right_diameter
            right_base_curve
            right_brand
            right_type
            right_supplier
            left_near_add_enum
            right_near_add_enum
          }
        }
      }
    }
  }
`;

export const GET_PDS = gql`
  query Pds {
    me {
      pds(first: 200) {
        data {
          id
          binocular_dist_pd
          right_monocular_dist_pd
          left_monocular_dist_pd
          right_height_multifocal
          left_height_multifocal
          frame_size
          created_at
        }
      }
    }
  }
`;
